import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import { Box, Grid, IconButton, ListItemButton, ListItemIcon, Modal, ListItemText, Paper, Typography, useMediaQuery, Button, Menu, MenuItem, Drawer, Badge } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../Assets/assetHelper';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import KenColors from '../../Helpers/Themes/kenColors';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';
import routes from '../../Utils/routes';
import MobileNavTabs from './MobileTabs';
import InAppNotifications from './InAppNotification/index';
import CalendarIcon from '../../Assets/icons_calendar.svg';
import SettingIcon from '../../Assets/icons_settings.svg';
import NotificationIcon from '../../Assets/icons_notification.svg';
import { getBasicProfileSetting, getNewsLetter } from '../../Utils/apiService';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import TimeTracker from '../../TimeTracker/TimeTracker';
import Configurl from '../../Configurl';
import flamelogo1 from '../../Assets/AlumniLogo.png'
import flamelogomobile from '../../Assets/AlumniLogo.png'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router-dom';
import Logo from '../../Assets/logo.png'
type Newsletter = {
  id: number;
  title: string;
  link: string;
  date: string;
};

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const location = useLocation();

  // Render only on /home

  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openNotification, setOpenNotification] = useState(false);
  const [activeIconIndex, setActiveIconIndex] = useState<number | null>(null);
  const [profileUrl, setProfileUrl] = useState('');
  const [profileName, setProfileName] = useState('');
  const [notificationCount, setNotificationCount] = useState(0);
  const [newsletters, setNewsletters] = useState<Newsletter[]>([]);
  const handleClickIcon = (index: number) => {
    // setActiveIconIndex(index === activeIconIndex ? null : index);
  };

  const handleOpenNotification = (event: React.MouseEvent<HTMLElement>) => {
    // setAnchorEl(event.currentTarget);
    setOpenNotification((prev) => !prev);
  };

  const handleCloseNotification = () => {
    setAnchorEl(null);
    setOpenNotification(false);
  };

  // Callback to update notification count when notifications are marked as read
  const handleNotificationCountUpdate = (newCount: number) => {
    setNotificationCount(Math.max(0, newCount));
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1025px)');
  const is1980 = useMediaQuery('(max-width:1280px)');
  const is1710 = useMediaQuery('(min-width:1710px)');

  const userData = user as AuthUser;

  const handleListClick = (path: string, index: number) => {
    console.log('Navigation path:', path);
    navigate(path);
    setAnchorEl(null);
    setTimeout(() => {
      navigate(path);

      if (path === '/landingpage') {
        dispatch({ type: 'LOGOUT' });
      }
    }, 50);
  };
  // console.log('userData123', userData);

useEffect(() => {
  getNewsLetter()
    .then((response) => {
      // Log the full response to verify structure
      console.log("Full newsletter response:", response);

      // Correct path based on your data
      const { publicUrl, name, createdDate } = response.data.data;

      const newNewsletter = {
        id: 1,
        title: name,
        link: publicUrl,
        date: new Date(createdDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
        }),
      };

      console.log("Newsletter data:", newNewsletter);
      setNewsletters([newNewsletter]);
    })
    .catch((error) => console.error("Error fetching newsletter:", error));
}, []);
  useEffect(() => {
    if (userData?.applicantId) {
      getBasicProfileSetting(userData.applicantId)
        .then((res) => {
          console.log('Profile data:', res);
          setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
          setProfileName(`${res?.accountDetails?.FirstName} ${res?.accountDetails?.LastName}`);
        })
        .catch((err) => {
          console.error('Error fetching profile:', err);
        });
    }
  }, [userData?.applicantId]);

  const fetchNotificationCount = async () => {
    try {
      const userid = userData?.applicantId;
      if (userid) {
        // Import the function from apiService
        const { getUnreadNotificationCount } = await import('../../Utils/apiService');
        const count = await getUnreadNotificationCount(userid);
        console.log('Notification count:', count);
        setNotificationCount(Math.max(0, count));
      }
    } catch (error) {
      console.error('Error fetching notification count:', error);
      setNotificationCount(0);
    }
  };

  useEffect(() => {
    fetchNotificationCount();
    const interval = setInterval(fetchNotificationCount, 30000);
    return () => clearInterval(interval);
  }, []);

  // console.log('innerwidth12', window.innerWidth);
  const { pathname, state } = useLocation();
  const navigateHistory = decodeURIComponent(pathname)
    .split('/')
    .filter((items) => {
      return items && items !== '';
    });
  console.log(navigateHistory?.[0], "paramsparamsparamsparams");
 
  return (
    <>
      {(user?.applicantEmail) && <TimeTracker userId={user.applicantId} email={user.applicantEmail} name={user.applicantName} />}
      {isMobile ? (
        <Grid container spacing={2} sx={{ height: '100vh' }}>
          <Grid item xs={12} sm={12}>
            <Paper sx={{ mt: 2, ml: 2, mr: 2, p: 1, height: 'auto', boxShadow: 'none !important' }}>
              <Grid item container spacing={1} xs={12} lg={12}>
                <Grid item xs={3.5} display={"flex"} flexDirection="column" justifyContent="center" alignItems="flex-start">
                  {(navigateHistory?.length > 1 || navigateHistory?.[0] === 'PhotoAlbumUpload') ? (
                    <IconButton
                      onClick={() => {
                        if (state?.fromProfile) {
                          navigate(routes.myProfile);
                        } else {
                          navigate(-1);
                        }
                      }}
                      sx={{
                        mt: 0.5,
                        p: 0.5,
                        color: '#3061FF',
                        '&:hover': {
                          backgroundColor: 'rgba(48, 97, 255, 0.1)'
                        }
                      }}
                    >
                      <ArrowBackIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <img
                      alt="logo"
                      style={{ width: "35px" }}
                      src='https://iimustorageprod.blob.core.windows.net/iimu-data/KISLogo.png'
                    />
                  )}
                </Grid>
                <Grid item xs={5} display={"flex"} justifyContent="center" alignItems="center">
                  <AppBreadCrumbs />
                </Grid>
                <Grid item xs={1} display={"flex"} justifyContent="center" alignItems="center">
                  <IconButton
                    sx={{
                      marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                      backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                      color: activeIconIndex === 3 ? '#5981FF' : 'black',
                      '&:hover': {
                        backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                      },
                    }}
                    onClick={(event) => {
                      handleClickIcon(3);
                      handleOpenNotification(event);
                    }}
                  >
                    <Badge badgeContent={notificationCount} color="error">
                      <img alt='' src={NotificationIcon} />
                    </Badge>
                  </IconButton>
                  {/* <InAppNotifications
                    anchorEl={anchorEl}
                    handleClosePopover={handleCloseNotification}
                    openpop={openNotification}
                    onNotificationCountUpdate={handleNotificationCountUpdate}
                  /> */}
                </Grid>
                <Grid item xs={2.5} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'right' }}>
                  <div>
                    <Button onClick={handleClick}>
                      {profileUrl ? (
                        <img
                          className={classes.profilImageMobileView}
                          src={profileUrl}
                          alt="profile"
                          style={{ width: '40px', height: '40px', cursor: 'pointer' }}
                        />
                      ) : (
                        <AccountCircleOutlinedIcon
                          sx={{
                            width: '40px',
                            height: '40px',
                            cursor: 'pointer',
                            color: "grey"
                          }}
                        />
                      )}
                    </Button>

                    <Drawer
                      anchor="right"
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        sx: {
                          width: '80%',
                          maxWidth: '320px',
                          paddingTop: '16px',
                          paddingBottom: '16px',
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Box sx={{ px: 3, mb: 3 }}>
                          {profileUrl ? (
                            <img
                              src={profileUrl}
                              alt="profile"
                              style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                              }}
                            />
                          ) : (
                            <AccountCircleOutlinedIcon
                              sx={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                                color: "grey"
                              }}
                            />
                          )}
                          <Typography sx={{ mt: 1, fontWeight: '500', fontSize: '16px' }}>
                            {profileName || 'User Name'}
                          </Typography>
                          {/* <Typography sx={{ color: '#666', fontSize: '14px', fontWeight: '400' }}>
 {userData?.applicantId || 'User ID'}
 </Typography> */}
                        </Box>

                        <Box sx={{
                          borderBottom: '1px solid #EAEFFF',
                          width: '100%',
                          mb: 2
                        }} />

                        <Box sx={{ flex: 1, overflowY: 'auto', px: 1 }}>
                          <MobileNavTabs
  handleListClick={handleListClick}
  name="mobile"
  handleClose={handleClose}
/>

                        </Box>
                      </Box>
                    </Drawer>
                  </div>
                </Grid>
              </Grid>
            </Paper>
            <Box
              sx={{
                overflow: 'auto',
                // height: '100vh',
                width: '100vw',
                scrollbarColor: 'white',
                p: navigateHistory?.[0] === 'my Feed' ? 0 : 2,
                scrollbarWidth: 'none',
              }}
            >
              {children}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2} style={{ padding: isMobile ? '4px 4px' : '' }} sx={{ width: '100vw', height: '100vh', padding: '15px',overflow:"hidden" }}>
          <Grid item xs={2} md={2}>
            <Paper className={classes.nav}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
                <div style={{ marginBottom: '10px' }}>
                  <img
                    className={classes.profilImage}
                    src={profileUrl ? profileUrl : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8oJh_Li1F9MTL485spsUw1L-cjntjj49vaCWWPZdjPoeZFH5lsCGjQlMZKwr1vNZUz6M&usqp=CAU"}
                    alt="profile"
                    style={{
                      width: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      height: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      // border: '3px solidrgb(202, 202, 202)',
                    }}
                    onClick={() => navigate(routes.settings)}
                  />
                  <Typography className={classes.profileName}>{userData?.applicantName ? (isMobile ? userData.applicantName.slice(0, 2).toUpperCase() : userData.applicantName) : ''}</Typography>
                  {userData?.graduationYear !== 'null' && <Typography className={classes.profileDesignation}>Class of {userData?.graduationYear ? userData?.graduationYear : '-'}</Typography>}
                </div>
                <div>
                  <SideNavTabs handleListClick={handleListClick} />
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={10} md={10}>
            <Grid container spacing={2}>
              <Grid item container spacing={3} xs={12} lg={12}>
          <Grid item xs={6} sm={8} md={is1710 ? 9 : 7} lg={is1710 ? 9 : 7}>
  <Paper
    className={classes.header}
    sx={{
      borderRadius: '9px !important',
      p: 2,
      // Add border only if on /home with newsletters
      border: location.pathname === '/home' && newsletters.length > 0 ? '1px solid #d0d7de' : 'none',
    }}
  >
    {/* Show breadcrumbs only if not on /home with a newsletter */}
    {!(location.pathname === '/home' && newsletters.length > 0) && <AppBreadCrumbs />}

    {/* Show only the latest newsletter on /home if available */}
    {location.pathname === '/home' && newsletters.length > 0 && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          height: '60px',
          boxSizing: 'border-box',
        }}
      >
        <Box>
          <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: 400 }}>
            Newsletter
          </Typography>

          <Typography variant="h5" fontWeight="600">
            {newsletters[0].title}
          </Typography>
        </Box>

        <Box>
          <Button variant="text" onClick={() => navigate('/resources')}>View More</Button>
          <Button variant="contained" color="primary" onClick={() => window.open(newsletters[0].link, '_blank')}>
            Read Now
          </Button>
        </Box>
      </Box>
    )}
  </Paper>
</Grid>
                <Grid item xs={6} sm={4} md={is1710 ? 3 : 3} lg={is1710 ? 3 : 5}>
              <Paper
  className={classes.actions}
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1, sm: 1.5, md: 2, lg: 2.5 }, // Optimized spacing between icons
    px: 2, // Optional: horizontal padding inside Paper
  }}
>
  <IconButton
    sx={{
      backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
      color: activeIconIndex === 1 ? '#5981FF' : 'black',
      '&:hover': {
        backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
      },
      width: { xs: 40, sm: 45, md: 50 }, // Increased icon button size
      height: { xs: 40, sm: 45, md: 50 },
    }}
    onClick={() => {
      handleClickIcon(1);
      navigate(routes.settings);
    }}
  >
    <img alt='' src={SettingIcon} style={{ width: '24px', height: '24px' }} /> {/* Increased icon size */}
  </IconButton>

  <IconButton
    sx={{
      backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
      color: activeIconIndex === 2 ? '#5981FF' : 'black',
      '&:hover': {
        backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
      },
      width: { xs: 40, sm: 45, md: 50 },
      height: { xs: 40, sm: 45, md: 50 },
    }}
    onClick={() => {
      handleClickIcon(2);
      navigate(routes.chats);
    }}
  >
    <ModeCommentOutlinedIcon style={{ color: "#585a64", fontSize: "22px" }} /> {/* Increased size */}
  </IconButton>

  <IconButton
    sx={{
      backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
      color: activeIconIndex === 3 ? '#5981FF' : 'black',
      '&:hover': {
        backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
      },
      width: { xs: 40, sm: 45, md: 50 },
      height: { xs: 40, sm: 45, md: 50 },
    }}
    onClick={(event) => {
      handleClickIcon(3);
      handleOpenNotification(event);
    }}
  >
    <Badge badgeContent={notificationCount} color="error">
      <img alt='' src={NotificationIcon} style={{ width: '24px', height: '24px' }} />
    </Badge>
  </IconButton>

  <InAppNotifications
    anchorEl={anchorEl}
    handleClosePopover={handleCloseNotification}
    openpop={openNotification}
    onNotificationCountUpdate={handleNotificationCountUpdate}
  />

  <div style={{ width: '1px', height: '60px', background: '#C6C9D2' }} /> {/* Slightly thinner divider */}

  <img
    alt="logo"
    className={classes.actionLogo}
    src={'https://iimustorageprod.blob.core.windows.net/iimu-data/KISLogo.png'}
    style={{ width: '70px', height: 'auto' }} // Adjust logo size
  />
</Paper>

                </Grid>
              </Grid>
              <Box
                sx={{
                  overflow: 'auto',
                  // overflow: isMobile ? 'auto' : 'hidden',
                  // height: '100vh',
                  // width: '100vw',
                  height: `calc(100vh - 75px)`,
                  width: `calc(100vw - 30px)`,
                  scrollbarColor: 'white',
                  paddingTop: '3px',
                  paddingLeft: '22px',
                  scrollbarWidth: 'none',
                }}
              >
                {children}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Mobile InAppNotifications */}
      {isMobile && (
        <InAppNotifications
          anchorEl={anchorEl}
          handleClosePopover={handleCloseNotification}
          openpop={openNotification}
          onNotificationCountUpdate={handleNotificationCountUpdate}
        />
      )}
    </>
  );
};

export default AppLayout;